import { FunctionComponent, ReactNode } from "react";
import classNames from "classnames";

import "./styles.scss";

type Props = {
  isLoading?: boolean;
  children: ReactNode;
  type?: "button" | "submit" | "reset";
  modifier?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "fourth"
    | "fifth"
    | "whatsapp";
  applyNewSize?: boolean; // temporary prop
  className?: string;
  disabled?: boolean;
  onClick?: (args: any) => void;
  id?: string;
};

const Button: FunctionComponent<Props> = ({
  children,
  isLoading = false,
  modifier = "primary",
  applyNewSize = false,
  type = "button",
  className,
  disabled = false,
  onClick,
  id,
}) => {
  return (
    <button
      onClick={onClick}
      className={classNames("button", `button--${modifier}`, className, {
        button__loading: isLoading,
        [`button--disabled`]: disabled,
        "button--new-size": applyNewSize, // temp size that seems to be the end goal on figma, ig your button applies, use it
      })}
      type={type}
      disabled={disabled || isLoading}
      id={id}
    >
      {!isLoading && children}
      {isLoading && (
        <div
          className={classNames(
            "button__spinner",
            `button__spinner--${modifier}`
          )}
        />
      )}
    </button>
  );
};

export default Button;
